import * as d3 from 'd3'
import { D3Module } from '@bpchart/types'
import { ButtonParams } from './types'

export default abstract class Button implements D3Module<ButtonParams> {
  public selection: d3.Selection<any, unknown, any, unknown>
  public params: ButtonParams = {
    // id: 'bpchart_button',
    // disabled: false
  }
  protected buttonSelection: d3.Selection<SVGGElement, unknown, any, unknown> | undefined

  constructor (selection: d3.Selection<any, unknown, any, any>, params?: ButtonParams) {
    this.selection = selection
    if (params) {
      this.params = params
    }
    // if (params.id) {
    //   this.params.id = params.id
    // }
    // if (params.disabled) {
    //   this.params.disabled = params.disabled
    // }
  }

  public abstract render (): void

  public remove () {
    this.buttonSelection!.remove()
  }

  public select () {
    return this.buttonSelection!
  }

  // public abstract disabled (isDisabled: boolean): void
}
